(function () {
	const initProductAccordion = () => {
		$(".product-about__accordion-title").click(function () {
			var $title = $(this);

			if (!$title.hasClass("active")) {
				$(".product-about__accordion-title.active").removeClass("active");
				$title.addClass("active");
				$(".product-about__accordion-content").stop().slideUp(200);
				$title
					.siblings(".product-about__accordion-content")
					.eq($title.index())
					.stop()
					.slideDown(200, function () {
						// WICHER - po otwarciu nowej sekcji przewiń tak, żeby jej tytuł był widoczny na górze (z uwzględnieniem sticky headera)
						var headerEl = document.querySelector('.shopify-section-header-sticky, sticky-header, .header-wrapper');
						var headerHeight = headerEl ? headerEl.offsetHeight : 0;
						var top = $title.offset().top - headerHeight - 16;
						window.scrollTo({ top: top, behavior: 'smooth' });
					});
			} else {
				$title.removeClass("active");
				$title
					.siblings(".product-about__accordion-content")
					.stop()
					.slideUp(200);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();